import { IconProps } from './IconProps';

export const RewindWhite = (props: IconProps) => {
  return (
    <svg
      style={props.style}
      className={props.className}
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3833 0.237632C24.0167 -0.236208 24.4802 0.020349 24.4802 0.813512V15.1895C24.4802 15.9748 24.0169 16.2365 23.3833 15.7654L14.2216 8.86509C13.9247 8.68013 13.743 8.35601 13.7403 8.00618C13.7377 7.65633 13.9143 7.32947 14.2086 7.13997L23.3833 0.237632Z"
        fill="white"
      />
      <path
        d="M9.64308 0.237632C10.2765 -0.236208 10.7399 0.020349 10.7399 0.813512V15.1895C10.7399 15.9748 10.2767 16.2365 9.64308 15.7654L0.481346 8.86509C0.184267 8.68013 0.00278525 8.35601 2.73835e-05 8.00618C-0.00252893 7.65633 0.17404 7.32947 0.468211 7.13997L9.64308 0.237632Z"
        fill="white"
        fillOpacity="0.4"
      />
    </svg>
  );
};

